@if (failure(); as authFailure) {
  <div
    class="auth-recovery-panel tw:fixed tw:top-0 tw:left-0 tw:w-full tw:h-full tw:bg-surface-0 tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:px-6 tw:text-center"
  >
    <pinnakl-icon
      class="tw:flex tw:h-8 tw:w-8 tw:text-p-orange-500"
      name="icon-warning"
    />
    <div class="tw:text-[1.125rem] tw:font-semibold">{{ authFailure.title }}</div>
    <div class="tw:text-bluegray-600 tw:max-w-120">
      {{ authFailure.message }}
    </div>
    <prime-button
      severity="primary"
      label="Try again"
      (onClick)="retry()"
    />
  </div>
}
